'use client'

import { ArrowLeftIcon as ArrowLeft, ArrowRightIcon as ArrowRight } from '@heroicons/react/24/solid'


export interface NextArrowProps {
  nextArrowClass?: string
  onClick?: () => void
  infinite: boolean
}

export interface PrevArrowProps {
  prevArrowClass?: string
  onClick?: () => void
  infinite: boolean
}


export const NextArrow = ({ onClick, infinite, nextArrowClass }: NextArrowProps) => {
  return (
    <div
      className={[
        'flex absolute top-1/2 right-1 -translate-y-1/2 w-10 h-10 shadow-md rounded-full items-center justify-center z-10',
        onClick === null && !infinite
          ? 'cursor-not-allowed bg-[#eeefef]'
          : 'cursor-pointer bg-white',
        nextArrowClass,
      ].join(' ')}
      onClick={onClick}
      data-role='none'
    >
      <ArrowRight width={16} height={16} strokeWidth={2} />
    </div>
  )
}

export const PrevArrow = (props: PrevArrowProps) => {
  const { onClick, infinite, prevArrowClass } = props
  return (
    <div
      className={[
        'absolute top-1/2 left-1 -translate-y-1/2 w-10 h-10 shadow-md rounded-full flex items-center justify-center z-10',
        onClick === null && !infinite
          ? 'cursor-not-allowed bg-[#eeefef]'
          : 'cursor-pointer bg-white',
        prevArrowClass,
      ].join(' ')}
      onClick={onClick}
      data-role='none'
    >
      <ArrowLeft width={16} height={16} strokeWidth={2} />
    </div>
  )
}
